import { DesigntimeComponent } from './DesigntimeComponent.js'
import * as $ from 'jquery';

class LogicGreatest extends DesigntimeComponent {
    static staticName = "Logic: Greatest";
    static staticId = "logicGreatest";
    hasRuntimeView = false;

    constructor(identifyer) {
        super(identifyer, 1);

        this.values = {
            equalAll: { value: "1, 1, 1, 2, 2, 3, 3", dontTranslate: true },
            equal1and2: { value: "1, 1, 1, 2, 2, 2, 2", dontTranslate: true },
            equal1and3: { value: "1, 1, 1, 1, 3, 3, 3", dontTranslate: true },
            equal2and3: { value: "2, 2, 2, 2, 3, 3, 3", dontTranslate: true },
        }

        this.params = {
            parameter1: { key: "url:monthlySpending", value: 0 },
            parameter2: { key: "url:monthlySpending", value: 0 },
            parameter3: { key: "url:monthlySpending", value: 0 },
        };
    }

    getRuntimeView(context) {
        this.eventBroker.subscribe("valueChangedEvent", this.onRuntimeChanged.bind(this));
        return $("<div class='logicGreatest'></div>");
    }

    onRuntimeChanged(eventParams) {
        if (eventParams.id == this.id)
            return;

        if (this.params.parameter1.key != eventParams.key && this.params.parameter2.key != eventParams.key && this.params.parameter3.key != eventParams.key) {
            return;
        }

        if (this.params.parameter1.key == eventParams.key) {
            this.params.parameter1.value = parseInt(eventParams.value);
        }
        if (this.params.parameter2.key == eventParams.key) {
            this.params.parameter2.value = parseInt(eventParams.value);
        }
        if (this.params.parameter3.key == eventParams.key) {
            this.params.parameter3.value = parseInt(eventParams.value);
        }

        if (this.params.parameter1.value > this.params.parameter2.value && this.params.parameter1.value > this.params.parameter3.value) {
            this.eventBroker.fireValueChanged(this.id, "parameter1", true);
            this.eventBroker.fireValueChanged(this.id, "parameter2", false);
            this.eventBroker.fireValueChanged(this.id, "parameter3", false);
            return;
        }

        if (this.params.parameter2.value > this.params.parameter1.value && this.params.parameter2.value > this.params.parameter3.value) {
            this.eventBroker.fireValueChanged(this.id, "parameter1", false);
            this.eventBroker.fireValueChanged(this.id, "parameter2", true);
            this.eventBroker.fireValueChanged(this.id, "parameter3", false);
            return;
        }

        if (this.params.parameter3.value > this.params.parameter1.value && this.params.parameter3.value > this.params.parameter2.value) {
            this.eventBroker.fireValueChanged(this.id, "parameter1", false);
            this.eventBroker.fireValueChanged(this.id, "parameter2", false);
            this.eventBroker.fireValueChanged(this.id, "parameter3", true);
            return;
        }

        let selectedMax = 0;

        if (this.params.parameter1.value == this.params.parameter2.value && this.params.parameter1.value == this.params.parameter3.value) {
            selectedMax = this.getValueFrom(this.params.parameter1.value, this.values.equalAll.value);
        }
        else if (this.params.parameter1.value == this.params.parameter2.value) {
            selectedMax = this.getValueFrom(this.params.parameter1.value, this.values.equal1and2.value);
        }
        else if (this.params.parameter1.value == this.params.parameter3.value) {
            selectedMax = this.getValueFrom(this.params.parameter1.value, this.values.equal1and3.value);
        }
        else if (this.params.parameter2.value == this.params.parameter3.value) {
            selectedMax = this.getValueFrom(this.params.parameter2.value, this.values.equal2and3.value);
        }

        this.eventBroker.fireValueChanged(this.id, "parameter1", selectedMax == 1);
        this.eventBroker.fireValueChanged(this.id, "parameter2", selectedMax == 2);
        this.eventBroker.fireValueChanged(this.id, "parameter3", selectedMax == 3);
    }

    getValueFrom(index, arrayString) {
        let arr = arrayString.split(",");
        if (arr.length < index)
            return +arr[arr.length - 1];
        return +arr[index - 1];
    }

    output = [
        { name: "parameter1", type: "bool" },
        { name: "parameter2", type: "bool" },
        { name: "parameter3", type: "bool" }
    ];
}

export { LogicGreatest }
